import api from '../api';

export const getAttributes = (search = '') => {
  const params = search ? { search } : {};
  return api.get('/products/attributes/', { params });
};

export const getAttribute = (id) => {
  return api.get(`/products/attributes/${id}/`);
};

export const createAttribute = (data) => {
  return api.post('/products/attributes/', data);
};

export const updateAttribute = (id, data) => {
  return api.put(`/products/attributes/${id}/`, data);
};

export const deleteAttribute = (id) => {
  return api.delete(`/products/attributes/${id}/`);
};